module.exports = __webpack_public_path__ + "img/up-cultura-scoala.0a270734.png";